const regoodsinfo = resolve => require(['@/pages/deal/customerservice/customerserviceinfo/index.vue'], resolve);
const regoods = resolve => require(['@/pages/deal/customerservice/index.vue'], resolve);
const evaluate = resolve => require(['@/pages/deal/evaluate/index.vue'], resolve);
const storeinvoices = resolve => require(['@/pages/deal/serorders/details/storeinvoices/index.vue'], resolve);
const details = resolve => require(['@/pages/deal/serorders/details/index.vue'], resolve);
const serorders = resolve => require(['@/pages/deal/serorders/index.vue'], resolve);
const handleregoods = resolve => require(['@/pages/deal/handleregoods/index.vue'], resolve);
// const plusMember = resolve => require(['@/pages/deal/plusMember/index.vue'], resolve);

export default [
  /*****************交易管理*******************/
  {
    path: "/plforders",
    name: "平台订单管理"
  },
  //商家订单管理
  {
    path: "/serorders",
    name: "商家订单管理",
    component: serorders,
    meta: {
      keepAlive: true
    }
  },
  /*商家订单管理下的路由开始*/
  {
    path: "/serorders/details",
    name: "订单详情",
    component: details
  },
  {
    path: "/serorders/storeinvoices",
    name: "发票详情",
    component: storeinvoices
  },
  /*商家订单管理下的路由结束*/
  //评价管理
  {
    path: "/evaluate",
    name: "评价管理",
    component: evaluate
  },
  //退货管理
  {
    path: "/regoods",
    name: "退货管理",
    component: regoods,
    meta: {
      keepAlive: true
    }
  },
  /*退货管理下路由开始*/
  {
    path: "/regoods/regoodsinfo",
    name: "售后详情",
    component: regoodsinfo
  },
  /*退货管理下路由结束*/
  //退货处理
  {
    path: "/handleregoods",
    name: "售后处理",
    component: handleregoods,
    meta: {
      keepAlive: true
    }
  },
//   {
//     path: "/plusMember",
//     name: "plus会员开户",
//     component: plusMember,
//     meta: {
//       keepAlive: true
//     }
//   },
  /*退货处理下路由开始*/
  {
    path: "/handleregoods/regoodsinfo",
    name: "退货处理售后详情",
    component: regoodsinfo
  },
  /*退货处理下路由结束*/
]
